export var StayTypesEnum;
(function (StayTypesEnum) {
    StayTypesEnum[StayTypesEnum["Hotels"] = 0] = "Hotels";
    StayTypesEnum[StayTypesEnum["VacationRentals"] = 1] = "VacationRentals";
})(StayTypesEnum || (StayTypesEnum = {}));
//# sourceMappingURL=interfaces.js.map